var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"18","viewBox":"0 0 195 146","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0H195.03V146H0V0Z","fill":"#C8102E"}}),_c('path',{attrs:{"d":"M62.6743 0H83.5759V146H62.6743V0Z","fill":"white"}}),_c('path',{attrs:{"d":"M0 62.5669H195.03V83.4327H0V62.5669Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }